// extracted by mini-css-extract-plugin
module.exports = {"listArrangementContainer":"SetupCard_listArrangementContainer__13cfs"};